import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';

import { FaMobileScreen } from 'react-icons/fa6';



const Banner = () => {

  return (
    <section className="banner">
      <div className='content'>

        <Heading title={"Reliable & Affordable Car Rental Services"} subTitle={"Rent Your Car"} linear />

        {/* Contact Information */}
        <div className="rental-call">
          <div className="icon"><FaMobileScreen /></div>
          <span>1234-567-890</span>
        </div>

        <Button link={"Car-Booking"} title={"Rent A Car"} />

      </div>
    </section>
  );
};

export default Banner;